// extracted by mini-css-extract-plugin
module.exports = {"card":"antdCard_card__1yjoo"};